<template>

  <div>
    <!-- Filters -->
    <approval-filter
        :tipe-options="tipeOptions"
        :tipe-filter.sync="tipeFilter"
        :status-options="statusOptions"
        :status-filter.sync="statusFilter"
    />


    <!-- Table Container Card -->
    <b-card
        no-body
        class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Tampilkan</label>
            <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
            />
            <label>data</label>
          </b-col>

          <!-- Search -->
          <b-col
              cols="12"
              md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  placeholder="Search..."
              />
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
          ref="refListTable"
          class="position-relative"
          :items="fetch"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="Tidak ada data"
          :sort-desc.sync="isSortDirDesc"
      >

        <template #cell(status)="data">
          <b-badge
              pill
              :variant="`light-${resolveStatusVariant(data.item.status)}`"
              class="text-capitalize"
          >
            {{ resolveStatusVariantLabel(data.item.status) }}
          </b-badge>
        </template>

        <template #cell(evidence)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-badge
                  @click="handleShowLighbox(data.item.evidence)" v-if="data.item.evidence"
                  pill
                  :variant="`light-primary`"
                  class="text-capitalize"
              >
               <a class="text-primary"> Klik di sini</a>
              </b-badge>
            </template>
          </b-media>
        </template>


        <template #cell(tipe)="data">
          <b-badge
              pill
              :variant="`light-${resolveTipeVariant(data.item.tipe)}`"
              class="text-capitalize"
          >
            {{ resolveTipeVariantLabel(data.item.tipe) }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div v-if="data.item.status === 'waiting'">
            <b-button variant="relief-success"
                      @click="approved(data.item.id, resolveTipeVariantLabel(data.item.tipe), data.item.nama )">
              Setujui
            </b-button>
            &nbsp;
            <b-button variant="relief-danger"
                      @click="rejected(data.item.id, resolveTipeVariantLabel(data.item.tipe), data.item.nama )">
              Tolak
            </b-button>
          </div>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Menampilkan {{ dataMeta.from }} sampai {{ dataMeta.to }} dari {{ dataMeta.of }} data</span>
          </b-col>
          <!-- Pagination -->
          <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
                v-model="currentPage"
                :total-rows="total"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
    <vue-easy-lightbox
        scrollDisabled
        moveDisabled
        :visible="lighboxVisible"
        :imgs="lighboxImage"
        @hide="handleHideLighbox"
    ></vue-easy-lightbox>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import {ref, onUnmounted} from '@vue/composition-api'
import approvalFilter from './ApprovalFilter'
import approvalList from "./ApprovalList"
import approvalStoreModule from "./ApprovalStoreModule"
import {avatarText} from '@core/utils/filter'
import VueEasyLightbox from "vue-easy-lightbox";

export default {
  components: {
    approvalFilter,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    VueEasyLightbox,


    vSelect,
  },
  props: {
    filter: {
      type: Boolean,
      default: true,
      required: false
    },
  },
  computed: {
    user() { return this.$store.getters.user },
  },
  data() {
    return {
      lighboxVisible: false,
      lighboxImage: null,
    }
  },
  setup() {
    const APP_STORE_MODULE_NAME = 'app-approval'
    // Register module
    if (!store.hasModule(APP_STORE_MODULE_NAME)) store.registerModule(APP_STORE_MODULE_NAME, approvalStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(APP_STORE_MODULE_NAME)) store.unregisterModule(APP_STORE_MODULE_NAME)
    })

    const isAddSidebarActive = ref(false)

    const {
      fetch,
      tableColumns,
      perPage,
      currentPage,
      total,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      resolveStatusVariantLabel,
      resolveTipeVariantLabel,

      refetchData,
      // Filter

      //Extra Filter
      statusFilter,
      tipeFilter,
      pengawasId
    } = approvalList()

    const statusOptions = [
      {
        'label': "Menunggu Persetujuan",
        'value': 'waiting'
      }, {
        'label': "Disetujui",
        'value': 'approved'
      }, {
        'label': "Ditolak",
        'value': 'rejected'
      }
    ]

    const tipeOptions = [
      {
        'label': "Sakit",
        'value': 'sakit'
      },
      {
        'label': "Work From Home",
        'value': 'wfh'
      },
      {
        'label': "Izin",
        'value': 'izin'
      }, {
        'label': "Dinas Keluar",
        'value': 'dinas'
      },
    ]

    const resolveStatusVariant = status => {
      if (status === 'waiting') return 'warning'
      if (status === 'approved') return 'primary'
      if (status === 'rejected') return 'danger'
      return 'primary'
    }

    const resolveTipeVariant = tipe => {
      if (tipe === 'dinas') return 'primary'
      if (tipe === 'izin') return 'secondary'
      if (tipe === 'wfh') return 'warning'
      return 'danger'
    }

    return {
      // Sidebar
      isAddSidebarActive,

      fetch,
      tableColumns,
      perPage,
      currentPage,
      total,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      avatarText,

      // UI
      resolveStatusVariant,
      resolveStatusVariantLabel,

      resolveTipeVariant,
      resolveTipeVariantLabel,


      statusOptions,
      tipeOptions,

      // Extra Filters
      statusFilter,
      tipeFilter,
      pengawasId
    }
  },
  methods: {
    handleHideLighbox() {
      this.lighboxImage = null
      this.lighboxVisible = false
    },
    handleShowLighbox(image) {
      this.lighboxImage = image
      this.lighboxVisible = true
    },
    approved(id, tipe, user) {
      this.$swal({
        title: 'Apa anda yakin?',
        text: "Anda akan menyetujui Pengajuan " + tipe + ' Oleh ' + user,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ya, setuju!',
        cancelButtonText: 'Tidak',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          store.dispatch('app-approval/approve', id)
              .then(() => {
                this.$swal({
                  icon: 'success',
                  title: 'Disetujui!',
                  text: 'Data pengajuan ' + tipe + ' Oleh ' + user + ' berhasil di setujui.',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
                this.refetchData()
              })
        }
      })
    },
    rejected(id, tipe, user) {
      this.$swal({
        title: 'Apa anda yakin?',
        text: "Anda akan menolak pengajuan " + tipe + ' Oleh ' + user,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ya, tolak!',
        cancelButtonText: 'Tidak',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$swal({
            title: "Mohon berikan alasan!",
            input: 'text',
            showCancelButton: true,
            closeOnConfirm: false,
            animation: "slide-from-top",
            inputPlaceholder: "Alasan penolakan",
            confirmButtonText: 'Simpan',
            cancelButtonText: 'Batal',
            customClass: {
              confirmButton: 'btn btn-primary',
              cancelButton: 'btn btn-outline-danger ml-1 text-danger',
            },
            preConfirm: (value) => {
              if (!value) {
                this.$swal.showValidationMessage(
                    'Anda harus memasukan alasan'
                )
              }
            }
          }).then(result => {
            store.dispatch('app-approval/reject', {id: id, alasan: result.value})
                .then(() => {
                  this.$swal({
                    icon: 'success',
                    title: 'Ditolak!',
                    text: 'Data pengajuan ' + tipe + ' Oleh ' + user + ' berhasil di tolak.',
                    customClass: {
                      confirmButton: 'btn btn-success',
                    },
                  })
                  this.refetchData()
                })
          });
        }
      })
    }
  },
  created() {
    if(this.user.type === 'Pengawas'){
      this.pengawasId = this.user.id
    }
  }
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
